import styled from 'styled-components';

export const AccordionV2Wrapper = styled.div`
  display: block;
  width: 100%;
  margin: auto;
`;
